/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocateResult
 */
export interface LocateResult {
    /**
     * 
     * @type {string}
     * @memberof LocateResult
     */
    path: string | null;
    /**
     * 
     * @type {number}
     * @memberof LocateResult
     */
    workspace?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LocateResult
     */
    workspaceRelativePath?: string | null;
}

export function LocateResultFromJSON(json: any): LocateResult {
    return LocateResultFromJSONTyped(json, false);
}

export function LocateResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocateResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
        'workspace': !exists(json, 'workspace') ? undefined : json['workspace'],
        'workspaceRelativePath': !exists(json, 'workspace_relative_path') ? undefined : json['workspace_relative_path'],
    };
}

export function LocateResultToJSON(value?: LocateResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
        'workspace': value.workspace,
        'workspace_relative_path': value.workspaceRelativePath,
    };
}


